import { Translator } from '../../types/ApiResponseTypes'
import { OrderResponse, isOrderListResponse } from '../../types/order/OrderResponse'
import { Order, OrderList, OrderInstallation } from '../../types/order/OrderType'
import { parseIsoDate } from '../../utils/common'

class OrderResponseTranslator implements Translator<OrderList> {
  convert(response: any): OrderList {
    if (isOrderListResponse(response)) {
      const orderObject: Array<Order> = []
      if (Array.isArray(response.orders)) {
        response.orders.forEach((order: OrderResponse) => {
          orderObject.push(this.convertToOrderModel(order))
        })
        return { total: response.total, page: response.page, orders: orderObject }
      }
    }
    return { total: 0, page: 0, orders: [] }
  }

  convertToOrderModel(order: OrderResponse): Order {
    const installations: OrderInstallation[] = []
    order.installations.forEach((install) => {
      installations.push({
        date: parseIsoDate(install.date),
        type: install.type,
        typeId: install.typeId,
        status: install.status,
        statusId: install.statusId,
      })
    })
    return {
      id: order.orderId,
      orderId: order.orderId,
      date: parseIsoDate(order.date),
      description: order.description,
      statusId: order.statusId,
      status: order.status,
      partner: order.partner,
      options: order.options,
      installations: installations,
    }
  }
}
export default new OrderResponseTranslator()
